import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from '../styles/EmptyState.module.css';

/**
 * Empty state component for tables with no results
 * @param {Object} props Component props
 * @param {string} props.message The message to display
 * @param {Object} props.icon FontAwesome icon to display
 * @param {string} props.actionText Optional button text
 * @param {Function} props.actionHandler Optional button click handler
 * @returns {JSX.Element}
 */
const EmptyState = ({ message, icon, actionText, actionHandler }) => {
  return (
    <div className={styles.container}>
      <div className={styles.icon}>
        <FontAwesomeIcon icon={icon} size="4x" />
      </div>
      <p className={styles.message}>{message}</p>
      
      {actionText && actionHandler && (
        <button 
          className={styles.actionButton} 
          onClick={actionHandler}
        >
          {actionText}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
